import { CSSObject, DefaultTheme, useTheme } from "styled-components";

interface SnackBarStyles {
  container: CSSObject;
  closeButton: CSSObject;
  alert: CSSObject;
}

export const useSnackBarStyles = (): SnackBarStyles => {
  const theme: DefaultTheme = useTheme();
  return {
    container: {
      position: "fixed",
      right: `${theme.spaceUnits.sp01 * 4}px`,
      bottom: `${theme.spaceUnits.sp01 * 4}px`,
      width: "27%",
      zIndex: 9999,
    },
    alert: {
      color: theme.palette.white,
    },
    closeButton: {
      position: "fixed",
      right: `${theme.spaceUnits.sp01 * 7}px`,
    },
  };
};
